import iView from 'iview';
import Store from '@/store/index';

export const formsValidationErrors = {
  writeArabicOnly: 'يرجى الإدخال بالعربية',
  shouldEqualToCount: count => `يجب أن يتكون من ${count} أرقام`,
  shouldToBeNumbersOnly: `يجب أن يتكون من أرقام فقط`,
  shouldPhoneNumberStartWith05: 'يجب أن يبدأ رقم الهاتف بـ 05',
  shouldNumberStartBy: (numbers) => {
    let numbersArr = numbers.split(',');
    let result = 'يجب أن يبدأ الرقم بـ';
    return result + numbersArr.join(' أو ');
  },
  shouldSocialIdNumberIn10Digits: 'رقم الهوية يجب أن يكون مكون من 10 أرقام',
  noSpecialCharacter: 'لا يمكن أن يحتوي على رموز خاصة',
  shouldEnglishLettersOrNumbers: 'يرجي إدخال حروف أو أرقام إنجليزية فقط',
  maxLength: number => `يجب أن لا يكون اكبر من  ${number}`,
  age: year => `يجب أن يكون العمر ${year} عام`,
  max_age: year => `يجب أن يكون العمر اصغر من ${year} عام`,
  min_age: year => `يجب أن يكون العمر اكبر من ${year} عام`,
};

export const formFieldTypes = {
  text: 1,
  number: 2,
  date: 3,
  selectbox: 4,
  checkbox: 5,
  textarea: 6,
  radioButton: 7,
  multipleSelectBox: 8,
  fieldsSection: 11,
  button: 21,
  dataGrid: 22,
  map: 23,
  formula: 24,
  editableMultipleSelectBox: 25,
};

export const isEmptyOrSpaces = (value) => {
  return (value !== 0 && !value) || value.toString().match(/^ *$/) !== null;
};

export const validateInputArabic = (rule, value, callback) => {
  const arregex = /[\u0600-\u06FF]/;
  if (value && arregex.test(value) === false) {
    return callback(new Error(formsValidationErrors.writeArabicOnly));
  }
  return callback();
};

export const checkFirstTwoNumberOfPhoneNumber = (rule, value, callback) => {
  if (value && value.length && (value[0] !== 0 || value[1] !== 5)) {
    return callback(new Error(formsValidationErrors.shouldPhoneNumberStartWith05));
  }
  return callback();
};

export const isNumeric = (rule, value, callback) => {
  if (!isNaN(value)) {
    return callback();
  }
  return callback(new Error(formsValidationErrors.shouldToBeNumbersOnly));
};

export const formValidations = {
  required: options => ({
    required: true,
    type: (options && options.type) || 'string',
    message: (options && options.message) || 'الرجاء تعبئة الحقول الالزامية',
    trigger: (options && options.trigger) || 'change',
    validator: (rule, value, callback) =>
      isEmptyOrSpaces(value) ? callback(new Error()) : callback(),
  }),
  conditionalRequired: (options) => {
    return {
      required: options.condition,
      type: (options && options.type) || 'string',
      message: (options && options.message) || 'الرجاء تعبئة الحقول الالزامية',
      trigger: (options && options.trigger) || 'blur',
      validator: (rule, value, callback) =>
        options.condition && isEmptyOrSpaces(value) ? callback(new Error()) : callback(),
    };
  },
  email: options => ({
    type: 'email',
    message: (options && options.message) || 'الرجاء كتابة البريد الإلكتروني بالصيغة الصحيحة',
    trigger: (options && options.trigger) || 'blur',
  }),
  numeric: options => ({
    type: (options && options.type) || 'string',
    message: (options && options.message) || 'يجب أن تكون القيمة المدخلة رقم',
    trigger: (options && options.trigger) || 'blur',
    validator: (rule, value, callback) =>
      value && isNaN(value) ? callback(new Error()) : callback(),
  }),
  length: (len, options) => ({
    len,
    type: (options && options.type) || 'string',
    message: 'length',
    trigger: (options && options.trigger) || 'blur',
  }),
  maxLength: (max, options) => ({
    max,
    type: (options && options.type) || 'string',
    message: (options && options.message) || formsValidationErrors.maxLength(max),
    trigger: (options && options.trigger) || 'blur',
  }),
  minLength: (min, options) => ({
    min,
    type: (options && options.type) || 'string',
    message: (options && options.message) || 'minLength',
    trigger: (options && options.trigger) || 'blur',
  }),
  validateArabic: () => ({
    validator: validateInputArabic,
    trigger: 'blur',
  }),
  isVerified: isVerified => ({
    trigger: 'blur',
    message: 'الرجاء التحقق من البيانات',
    validator: (rule, value, callback) => (isVerified ? callback() : callback(new Error())),
  }),
  validateInputEqualCount: count => ({
    trigger: 'blur',
    validator: (rule, value, callback) =>
      value && value.toString().length !== count
        ? callback(new Error(formsValidationErrors.shouldEqualToCount(count)))
        : callback(),
  }),
  checkFirstTwoNumberOfPhoneNumber: () => ({
    trigger: 'blur',
    validator: checkFirstTwoNumberOfPhoneNumber,
  }),
  checkIfFirstCharStartsBy: number => ({
    trigger: 'change',
    validator: (rule, value, callback) =>
      value && value.toString()[0] !== number
        ? callback(new Error(formsValidationErrors.shouldNumberStartBy(number)))
        : callback(),
  }),
};

export const formValidate = (context, name, callback = valid => valid) =>
  context.$refs[name].validate(callback);
export const formReset = (context, name) =>
  context.$nextTick(() => {
    context.$refs[name].errors.clear();
    context.$nextTick(() => {
      context.$refs[name].$validator.reset();
    });
  });
export const toaster = {
  success: (msg, duration) => {
    toasterFunc('success', msg, duration);
  },
  error: (msg, duration) => {
    toasterFunc('error', msg, duration);
  },
};

const toasterFunc = (type, msg, duration = 8) => {
  iView.Notice[type]({
    title: msg,
    top: 50,
    duration: duration,
  });
};

export const appLoader = {
  start() {
    Store.dispatch('GlobalModule/updateAppLoader', { visibility: true });
  },
  end() {
    Store.dispatch('GlobalModule/updateAppLoader', { visibility: false });
  },
  error() {
    Store.dispatch('GlobalModule/updateAppLoader', { visibility: false });
  },
};

export const overlayLoader = {
  start() {
    Store.dispatch('GlobalModule/updateOverlayLoader', { visibility: true });
  },
  end() {
    Store.dispatch('GlobalModule/updateOverlayLoader', { visibility: false });
  },
  error() {
    Store.dispatch('GlobalModule/updateOverlayLoader', { visibility: false });
  },
};

export const tooltipMode = {
  normal: 1,
  formatter: 2,
};
